/* eslint import/prefer-default-export: 0 */

import remote from './remote';

export function getBanners(data = {}) {
  return remote.get('banners', data);
}
